import React from 'react';
import { FiCode, FiSmartphone, FiCpu, FiTrendingUp } from 'react-icons/fi';
import {
  MaxWidth,
  Main,
  Card,
  IconWrap,
  Parag,
  Content,
  Title,
  Heading,
  Text,
} from './Services.elements';
import useInView from '../../useInView';

const SERVICES = [
  {
    icon: FiCode,
    title: 'Web Development',
    text: 'Fast, scalable full-stack web apps and corporate sites with React, Next.js, TypeScript and Tailwind — from landing pages to admin panels.',
  },
  {
    icon: FiSmartphone,
    title: 'Mobile Development',
    text: 'Cross-platform mobile apps with React Native — production-grade features, API integrations and a polished user experience.',
  },
  {
    icon: FiCpu,
    title: 'AI Product Engineering',
    text: 'AI-powered features and tools: content analysis, automation and LLM integrations, built end-to-end the way I do at Nailing.ai.',
  },
  {
    icon: FiTrendingUp,
    title: 'Product & Business Consulting',
    text: 'From idea to MVP — requirements analysis, product roadmap and technical architecture with a business-first mindset.',
  },
];

const head = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: 0.1 * i, ease: 'easeOut' },
  }),
};

function Services() {
  const [ref, inView] = useInView({ amount: 0.1 });

  return (
    <Main id="services">
      <MaxWidth>
        <Title variants={head} initial="hidden" animate="visible">
          What I can do for you
        </Title>
        <Heading variants={head} custom={1} initial="hidden" animate="visible">
          My Services
        </Heading>

        <Content ref={ref}>
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Card
                key={s.title}
                initial={{ opacity: 0, y: 28 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 28 }}
                transition={{ duration: 0.5, delay: 0.08 * i, ease: 'easeOut' }}
              >
                <IconWrap>
                  <Icon />
                </IconWrap>
                <Text>{s.title}</Text>
                <Parag>{s.text}</Parag>
              </Card>
            );
          })}
        </Content>
      </MaxWidth>
    </Main>
  );
}

export default Services;
